import { CategoryNaturalKey } from '../documents/models/category';
import { UserActionName } from './user-action';

type EmailNotificatonPreferencesActionsByCategory = {
    [key in CategoryNaturalKey]?: UserActionName;
};

export const emailNotificationPreferencesActions: EmailNotificatonPreferencesActionsByCategory = {
    'result-alerts': 'Change Result Alerts Email Preferences',
    'lab-reports': 'Change Lab Results Email Preferences',
    'data-revisions': 'Change Data Revisions Email Preferences',
    'site-actions': 'Change Site Actions Email Preferences',
    'site-communications': 'Change Communications Email Preferences',
    'sponsor-communications': 'Change Sponsor Communications Email Preferences',
    'lab-manuals': 'Change Lab Manuals Email Preferences',
    'training-materials': 'Change Training Materials Email Preferences'
};
